// extracted by mini-css-extract-plugin
module.exports = {"ingredients":"ingredient-group_ingredients__1WGNS pt-6 mb-2 pl-4","title":"ingredient-group_title__2rjbP text text_type_main-medium"};